export enum AktionTypeEnum {
    BLOG = "blog",
    FORUM = "forum",
    LINK = "link",
    LINK_INTERN = "link-intern",
    NACHRICHT = "nachricht",
    TYPEBOT = "typebot",
    WIKI = "wiki",
}
